import { MultiSelectOption } from '../common/MultiSelectOption';
import { UserDeviceStatus } from '../enums/UserDeviceStatus';
import { QueueModel } from '../models/QueueModel';
import {
    SelectOptionsServiceGetUserLabelsResult,
    SelectOptionsServiceGetUsersResult,
} from '../services/SelectOptionsService';
import { ListFilters } from './shared/ListFilters';

export interface AgentExtensionReportFilter {
    status?: MultiSelectOption<UserDeviceStatus> | null;
    user?: SelectOptionsServiceGetUsersResult | null;
    userLabel?: SelectOptionsServiceGetUserLabelsResult | null;
    queue?: QueueModel | null;
}

export interface AgentExtensionReportState extends ListFilters {
    filter: AgentExtensionReportFilter;
}

export enum AgentExtensionReportMutations {
    SET_SEARCH = 'agentExtensionReport_setSearch',
    SET_SORT = 'agentExtensionReport_setSort',
    SET_FILTER = 'agentExtensionReport_setFilter',
    CLEAR_FILTER = 'agentExtensionReport_clearFilter',
}

export enum AgentExtensionReportActions {
    CLEAR_FILTER = 'agentExtensionReport_clearFilter',
    SET_FILTER = 'agentExtensionReport_setFilter',
    SET_SEARCH = 'agentExtensionReport_setSearch',
    SET_SORT = 'agentExtensionReport_setSort',
}

export enum AgentExtensionReportGetters {
    ACTIVE_FILTERS = 'agentExtensionReport_activeFilters',
    DEFAULT_FILTER = 'agentExtensionReport_defaultFilter',
    FILTER = 'agentExtensionReport_filter',
    SEARCH = 'agentExtensionReport_search',
    SORT = 'agentExtensionReport_sort',
}
